import { useSelector, shallowEqual } from 'react-redux'
import { useMemo } from 'react'
import { prop, sortBy, toLower } from 'ramda'

import { AcquiringItem } from 'app/dataTypes/acquiring/settings'
import { getLastFirst } from 'app/common/lib/names'


type Item = AcquiringItem & {
  header: string | null
  sortable: string
}

export default function useStep1Items(acquiringItems: Map<string, AcquiringItem>) {
  const { data, loading } = useSelector((state: any) => state.students, shallowEqual)

  const items = useMemo(() => {
    const res = [] as Array<Item>
    for (const [ID, item] of acquiringItems) {
      const { enabled } = item
      const student = data[ID]
      if (enabled) {
        const { name } = student || {}
        const header = (
          name
          ? getLastFirst(name)
          : null
        )
        res.push({
          ...item,
          header,
          sortable: name && header ? toLower(header) : 'яяя',
        })
      }
    }
    return sortBy(prop('sortable'), res)
  }, [acquiringItems, data])

  return { items, loading }
}
